// src/utils/slug.js

/**
 * Generira SEO-prijazen 'slug' iz danega niza (npr. naslova oglasa).
 * @param {string} text - Vhodno besedilo.
 * @returns {string} - Generiran slug.
 */
export const generateSlug = (text) => {
    if (!text) return '';

    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrssssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return text.toString().toLowerCase()
        .replace(/\s+/g, '-') // Zamenjaj presledke z -
        .replace(p, c => b.charAt(a.indexOf(c))) // Zamenjaj posebne znake
        .replace(/&/g, '-and-') // Zamenjaj & z '-and-'
        .replace(/[^\w\-]+/g, '') // Odstrani vse ne-besedne znake
        .replace(/\-\-+/g, '-') // Zamenjaj večkratne -- z enim -
        .replace(/^-+/, '') // Odstrani - z začetka
        .replace(/-+$/, '') // Odstrani - s konca
        .slice(0, 75); // Omeji dolžino na 75 znakov
}